module.exports = __webpack_public_path__ + "static/media/P20-Tip-Solution-Blue.284cb02e.svg";